import { useEffect } from 'react';
import { useAppDispatch } from 'src/hooks/Redux/useAppDispatch';
import useAppSelector from 'src/hooks/Redux/useAppSelector';
import { fetchMessagesForMember } from 'src/redux/slices/circleDetailsSlice/circleDetailsSlice';
import { selectFullUserInfo } from 'src/redux/slices/loggedUserSlice';
import styles from './Profile.module.scss';
import { SubscriptionInfo } from './SubscriptionInfo/SubscriptionInfo';
import TabsMessages from './Tabs/Tabs';
import { UserInfo } from './UserInfo/UserInfo';

export const Profile = () => {
  const dispatch = useAppDispatch();
  const fullUserInfo = useAppSelector(selectFullUserInfo);

  useEffect(() => {
    dispatch(fetchMessagesForMember());
  }, [dispatch]);

  return (
    <div className={styles.container}>
      {fullUserInfo ? (
        <>
          <UserInfo {...fullUserInfo} />
          <SubscriptionInfo {...fullUserInfo} />
          <TabsMessages />
        </>
      ) : (
        <p>Error loading user data. Please try again.</p>
      )}
    </div>
  );
};
